<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOff_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M11 8.5v-5a3 3 0 0 0-3-3 2.99 2.99 0 0 0-2.952 2.526l5.908 5.909.005-.033c.02-.132.039-.265.039-.402m2 0v-1a.5.5 0 0 0-1 0v1c0 .442-.09.859-.222 1.257l.779.779c.28-.624.443-1.31.443-2.036M2.244 1.636l12.41 12.411a.5.5 0 1 1-.707.706l-2.583-2.583A4.95 4.95 0 0 1 8.5 13.472V15.5a.5.5 0 0 1-1 0v-2.051C4.98 13.194 3 11.086 3 8.5v-1a.5.5 0 0 1 1 0v1c0 2.206 1.794 4 4 4 1.025 0 1.94-.409 2.646-1.047l-.698-.698A2.96 2.96 0 0 1 8 11.5a3 3 0 0 1-3-3V5.806L1.537 2.343a.5.5 0 0 1 .707-.707"
        clip-rule="evenodd"
    />
</svg>
